<template>
  <el-dialog title="新建图文" @open="onOpen" append-to-body :visible.sync="showModal" width="808px">
    <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="80px">
      <el-form-item label="图文名称" prop="name">
        <el-input v-model="addForm.name"></el-input>
      </el-form-item>

      <el-form-item label="图片" prop="images">
        <el-button @click="showImageSelector">选择图片</el-button>
        <span>{{ addForm.images.length }}/35</span>
        <el-button type="text" style="margin-left: 10px" @click="addForm.images = []">清空</el-button>
        <div class="images-preview">
          <div v-for="img in addForm.images" :key="img.id">
            <em class="remove-icon el-icon-error" @click="removeImage(img)"></em>
            <img :class="img.height > img.width ? 'vertical' : 'horizontal'" :src="img.preview_url" alt="" />
          </div>
        </div>
      </el-form-item>

      <el-form-item label="音频">
        <el-button v-if="!addForm.audio.name" @click="showAudioSelector"> 选择音频 </el-button>
        <p v-show="addForm.audio.name">
          <span> {{ addForm.audio.name }}.{{ addForm.audio.source_file_type }}</span>
          <el-button type="text" @click="showAudioSelector">&emsp;修改</el-button>
        </p>
        <p style="font-size: 12px">仅支持mp3、m4a音频格式，如果不上传音频，系统会自动为您匹配选择一段纯音乐</p>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="showModal = false">取消</el-button>
      <el-button type="primary" :loading="addLoading" @click="onAddConfirm">新建</el-button>
    </div>

    <AssetsSelectorModal :visible.sync="selectorModal" v-bind="selectorProps" @confirm="onSelectorConfirm">
      <template v-slot:assetType="{ getData }">
        <el-radio
          v-model="selectorProps.assetType"
          :disabled="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]"
          @change="getData"
          :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
        >
          图片
        </el-radio>
        <el-radio
          v-model="selectorProps.assetType"
          :disabled="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          @change="getData"
          :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]"
        >
          音频
        </el-radio>
      </template>

      <template v-if="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]" v-slot:sizes="{ getData, width }">
        <el-select
          :style="{ width }"
          popper-class="creative-selector-el-select-popper"
          :popper-append-to-body="false"
          v-model="selectorProps.form.size"
          @change="getData"
        >
          <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
          <el-option v-for="item in imageSizes" :key="item.label" :label="item.label" :value="item.label"> </el-option>
        </el-select>
      </template>
    </AssetsSelectorModal>
  </el-dialog>
</template>

<script setup>
import { ref, computed, toRef } from 'vue'
import { addCarousel } from '@/api/toutiao.local.model'
import { getCarouselFormModel } from '../../../../model/form.js'

import AssetsSelectorModal, { makeSelectorForm } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { MATERIAL_TYPE_SIZES } from '@/views/create/bytedance/consts/creative.js'

// eslint-disable-next-line
const props = defineProps({ value: Boolean, form: Object, accountId: [Number, String] })
// eslint-disable-next-line
const emit = defineEmits(['input', 'show-carousel-selector', 'confirm'])

const addFormRef = ref(null)
const selectorModal = ref(false)
const selectorProps = ref({
  max: 35,
  assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
  form: { ...makeSelectorForm(), size: '' }
})

const imageSizes = [...MATERIAL_TYPE_SIZES[selectorProps.value.assetType], { label: '800*800' }]

const showModal = computed({
  get() {
    return props.value
  },
  set(v) {
    emit('input', v)
  }
})

const addLoading = ref(false)
const addForm = ref(getCarouselFormModel())

const addFormRules = {
  name: [
    { required: true, message: '请输入图文名称', trigger: 'blur' },
    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
  ],
  images: [
    {
      required: true,
      validator: (rule, value, callback) => {
        if (!value.length || value.length < 2) {
          return callback(new Error('请至少选择2个图片'))
        }
        callback()
      }
    }
  ]
}

// 新建图文时显示图片素材选择框
function showImageSelector() {
  selectorProps.value = {
    max: 35,
    assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
    form: { ...makeSelectorForm(), size: '1080*1920' }
  }
  selectorModal.value = true
}
// 新建图文时显示音频素材选择框
function showAudioSelector() {
  selectorProps.value = {
    max: 1,
    assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO],
    form: { ...makeSelectorForm(), size: '' }
  }
  selectorModal.value = true
}

function onOpen() {
  // addForm.value = props.form
}

function removeImage(img) {
  addForm.value.images = addForm.value.images.filter((item) => item.id !== img.id)
}

function onSelectorConfirm(assets) {
  const { assetType } = selectorProps.value
  switch (assetType) {
    case MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]:
      addForm.value.images = addForm.value.images.concat(assets).slice(0, 35)
      break
    case MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]:
      addForm.value.audio = assets[0]
      break
    default:
      break
  }

  addFormRef.value.clearValidate()
}

function onAddConfirm(img) {
  addFormRef.value.validate((valid) => {
    if (valid) {
      const params = {
        image_ids: addForm.value.images.map((item) => item.id),
        audio_id: addForm.value.audio.id,
        file_name: addForm.value.name,
        ad_account_id: props.accountId
      }
      addLoading.value = true
      addCarousel(params)
        .then((data) => {
          addLoading.value = false
          if (data) {
            emit('confirm')
            showModal.value = false
          }
        })
        .catch(() => {
          addLoading.value = false
        })
    }
  })
}
</script>

<style lang="scss" scoped>
.images-preview {
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 380px;
  overflow: auto;
  > div {
    background: #f3f3f3;
    width: 220px;
    height: 123.75px;
    text-align: center;
    position: relative;
    &:hover {
      .remove-icon {
        display: inline-block;
      }
    }

    .remove-icon {
      display: none;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      font-size: 20px;
      cursor: pointer;
      color: rgb(192, 0, 0);
    }
    .horizontal {
      width: 100%;
    }
    .vertical {
      height: 100%;
    }
  }
}
</style>
